import {Injectable} from "@angular/core";
import {IDataModel} from './../../services/IDataModel';
import {Http, URLSearchParams, RequestOptions} from '@angular/http';
import * as _ from "lodash";
import {
    LeadsFilter, LeadsModel, AssignOpenerToLeads, LeadUpdateModel, LeadStatusModel, LeadScheduleModel
} from "./leads.model";
import {LeadsStatusType} from "./leads.type";
import {LeadsReasonType} from "./leads.type";

@Injectable()
export class LeadsService implements IDataModel {

    public static LEAD_VISIBLE_SCHEDULE = 2;
    public static LEAD_VISIBLE_TRUE = 1;
    public static LEAD_VISIBLE_FALSE = 0;

    public static LEAD_FILTER_TODAY = 'today';
    public static LEAD_FILTER_OVERDUE = 'overdue';

    private API_ROOT:string = '/leads';

    constructor(private http: Http) {}

    getList(filter: LeadsFilter){
        let params: URLSearchParams = new URLSearchParams();
        for (let key in filter) {

            if (key == 'fields') {
                for (let key in filter.fields) {
                    let fieldName = Object.keys(filter.fields[key])[0];
                    params.set(fieldName, filter.fields[key][fieldName]);
                }
            } else {
                params.set(key, filter[key] === null ? 'null' : filter[key]);
            }
        }
        return this.http.get(this.API_ROOT, new RequestOptions({
                search: params
            }));
    }

    getOne(id: number) {
        return this.http.get(`${this.API_ROOT}/${id}`).map(res => res.json());
    }

    getScheduleLIst() {
        return this.http.get(`${this.API_ROOT}/schedule`)
    }

    getStats(openerId: any = null) {
        openerId = Math.round(1 * openerId);
        let url = `${this.API_ROOT}/stats` + (openerId ? '?opener_id=' + openerId : '');
        return this.http.get(url).map(res => res.json());
    }

    add (fields: LeadsModel) {
        return this.http.post(this.API_ROOT, fields)
    }

    assignOpener (fields: AssignOpenerToLeads) {
        return this.http.post(`${this.API_ROOT}/assign-opener`, fields)

    }

    edit (id: number, fields: LeadUpdateModel) {
        return this.http.put(`${this.API_ROOT}/${id}`, fields).map(res => res.json());
    }

    setStatus (id: number, fields: LeadStatusModel) {
        return this.http.put(`${this.API_ROOT}/${id}/status`, fields)
    }

    setSchedule (id: number, fields: LeadScheduleModel) {
        return this.http.put(`${this.API_ROOT}/${id}/schedule`, fields)
    }

    remove(id: number) {
        return this.http.delete(`${this.API_ROOT}/${id}`)
    }

    undoSchedule (id: any) {
        return this.http.put(`${this.API_ROOT}/${id}/schedule`, {undo: 'undo'});
    }

    globalSearch (filter: any) {
        var searchParams = new URLSearchParams();
        for (var i in filter) {
            if (! filter.hasOwnProperty(i)) continue;
            searchParams.append(i, filter[i]);
        }
        return this.http.get(`${this.API_ROOT}/global-search`, {search: searchParams}).map(res => res.json());
    }

    getSources () {
        return this.http.get(`${this.API_ROOT}/sources`).map(res => res.json());
    }

    getAllowedOpenersForStats() {
        return this.http.get(`${this.API_ROOT}/get-allowed-openers-for-stat`).map(res => res.json());
    }

    static getEmptyModel(): LeadUpdateModel {
        return {
            company_name: '',
            address: '',
            city: '',
            province_id: null,
            postal_code: '',
            telephone: '',
            contact: '',
        }
    }

    static getStatuses(){
        return [
            {'id': 1, 'name': "No Answer"},
            {'id': 2, 'name': "Not Available"},
            {'id': 3, 'name': "Not Interested"},
            {'id': 4, 'name': "Not Now In The Future"},
            {'id': 5, 'name': "Wrong Number"},
            {'id': 6, 'name': "Not In Service "},
            {'id': 7, 'name': "Out of Business"},
            {'id': 8, 'name': "Selling Business"},
            {'id': 11, 'name': "Non Qualified"},
            {'id': 12, 'name': "Existing Merchant"}
        ];
    }

    static getScheduleStatuses(){
        return [
            {'id': 3, 'name': "Not Interested"},
            {'id': 4, 'name': "Not Now In The Future"},
            {'id': 6, 'name': "Not In Service "},
            {'id': 7, 'name': "Out of Business"},
            {'id': 8, 'name': "Selling Business"},
        ];
    }

    public getAllStatuses(){
        return [
            {'id': LeadsStatusType.NO_ANSWER, 'name': "No Answer"},
            {'id': LeadsStatusType.NOT_AVAILABLE, 'name': "Not Available"},
            {'id': LeadsStatusType.NOT_INTERESTED, 'name': " Not Interested"},
            {'id': LeadsStatusType.NOT_NOW_IN_THE_FUTURE, 'name': "Not Now In The Future"},
            {'id': LeadsStatusType.WRONG_NUMBER, 'name': "Wrong Number"},
            {'id': LeadsStatusType.NOT_IN_SERVICE, 'name': "Not In Service"},
            {'id': LeadsStatusType.OUT_OF_BUSINESS, 'name': "Out of Business"},
            {'id': LeadsStatusType.SELLING_BUSINESS, 'name': "Selling Business"},
            {'id': LeadsStatusType.SCHEDULED_CALL_BACK, 'name': "Scheduled call back"},
            {'id': LeadsStatusType.GENERATE_LEAD, 'name': "Generate lead"},
            {'id': LeadsStatusType.NON_QUALIFIED, 'name': "Non Qualified"},
            {'id': LeadsStatusType.EXISTING_MERCHANT, 'name': "Existing Merchant"},
            {'id': LeadsStatusType.TRASH, 'name': "Trash"}
        ];
    }

    public getAllReasons() {
        return [
            {'id': LeadsReasonType.TOO_EXPENSIVE, 'name': "Too Expensive"},
            {'id': LeadsReasonType.DOESNT_NEED_MONEY, 'name': "Doesn't Need Money"},
            {'id': LeadsReasonType.SELLING_BUSINESS_REASON, 'name': "Selling Business"},
            {'id': LeadsReasonType.RETIRING, 'name': "Retiring"},
            {'id': LeadsReasonType.RECEIVED_MONEY_ELSEWHERE, 'name': "Received Money Elsewhere"},
            {'id': LeadsReasonType.NOT_ENOUGHT_MONEY, 'name': "Not Enough Money"},
            {'id': LeadsReasonType.WITHHOLDING, 'name': "Withholding"},
            {'id': LeadsReasonType.NO_PURPOSE, 'name': "No Purpose"},
            {'id': LeadsReasonType.CLOTHING_BUSINESS, 'name': "Closing Business"},
            {'id': LeadsReasonType.OTHER_REASON, 'name': "Other"}
        ];
    }

    public getStatusById(id): string {
        let status = _.find(this.getAllStatuses(), {id: id});
        return status ? status.name : '';
    }

    static getAssignOpenerToLeads(){
        return {
            'quantity': 0,
            'opener' : []
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/models/leads/leads.service.ts